export default __webpack_public_path__ + "static/media/headshot.89c32ee1.jpg";